<template>
  <section id="services" class="services">
    <div class="container fade-in">
      <div class="row">
        <div class="col-12">
          <h1 class="text-center">Haarlem's Beautyful Cosmetics</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 offset-sm-3 col-lg-4 offset-lg-4">
          <div class="cosmetics">
            <div class="cosmetic-card" id="makeup"></div>
            <router-link @click.native="scrollToTop()" to="/cosmetics">
              <button class="btn">Mehr Erfahren</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Services",
  created() {
    let width = window.innerWidth;
    let height = window.innerHeight;

    window.addEventListener('resize', function () {
      let widthDiff = Math.abs(width - window.innerWidth);
      let heightDiff = Math.abs(height - window.innerHeight);

      if (widthDiff > 115 || heightDiff > 115) {
        const cards = document.querySelectorAll('.service-card-content, .service-card-content-sm, .service-card-content-md');
        cards.forEach(card => {
          card.classList.add('hidden');
          card.classList.remove('active');
        });
      }
    });
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    collapse(element) {
      let selectedElement = element;

      // check viewport
      if (window.innerWidth < 567) {
        selectedElement = element + '-sm';
      }

      if (window.innerWidth < 992 && window.innerWidth > 567) {
        selectedElement = element + '-md';
      }

      /* REMOVE HIDDEN IF IT IS THE SAME ELEMENT */
      const content = document.querySelector('.' + selectedElement);
      if (!content.classList.contains('hidden')) {
        content.classList.add('hidden');
        return;
      }

      /* check every content card to prevent double content cards */
      const allOne = document.querySelectorAll('.service-card-content, .service-card-content-sm');
      allOne.forEach(card => {
        if (card.classList.contains(selectedElement)) {
          card.classList.remove('hidden');
        } else {
          card.classList.add('hidden');
        }
      });

      const allTwo = document.querySelectorAll('.service-card-content-md');
      allTwo.forEach(card => {
        if (card.classList.contains(selectedElement)) {
          card.classList.add('active');
          card.classList.remove('hidden');
        } else {
          card.classList.remove('active');
          card.classList.add('hidden');
        }
      });
      /*
      const allThree = document.querySelectorAll('.service-card-content');
      allThree.forEach(card => {
        if (card.classList.contains(selectedElement)) {
          card.classList.remove('hidden');
        } else {
          card.classList.add('hidden');
        }
      });
      */
    },

  },
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

.services {
  h1, h2 {
    text-transform: uppercase;
    letter-spacing: 4px;
    margin-bottom: 20px;
  }

  h2 {
    margin-top: 40px;
  }

  .service-card {
    position: relative;
    display: inline-block;
    width: 230px;
    height: 325px;
    left: 50%;
    margin-bottom: 25px;
    transform: translateX(-50%);
    background-color: $black;
    border-radius: 10px;
    cursor: pointer;
    @include transition;

    &:hover, &.active {
      background-color: lighten(#121212, 15);
    }

    .title {
      position: absolute;
      top: 8%;
      width: 100%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: $white;
      @include font-2;
      text-transform: uppercase;
      letter-spacing: 4px;
    }

    .inner-card {
      position: absolute;
      width: 80%;
      height: 70%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-size: cover;
      background-repeat: no-repeat;
    }

    #haarlem-cut {
      background-image: url("../../../assets/images/cut.jpg");
      background-position: 50% 50%;
    }

    #haarlem-colour {
      background-image: url("../../../assets/images/color.jpg");
      background-position: 50% 50%;
    }

    #wedding {
      background-image: url("../../../assets/images/wedding.png");
      background-position: 50% 50%;
    }

    #tape-extensions {
      background-image: url("../../../assets/images/extensions.jpg");
      background-position: 50% 50%;
    }
  }

  .plus-btn {
    position: absolute;
    top: 88%;
    left: 51%;
    width: 25px;
    height: 26px;
    transform: translateX(-50%);
    background-image: url("../../../assets/images/plus.svg");
    background-repeat: no-repeat;
    background-position: center;
  }

  /*** CONTENT CARDS ***/

  .service-card-content, .service-card-content-sm, .service-card-content-md {
    h1, h2, p, li {
      color: $white;
    }

    ul > li {
      margin-left: 15px;
    }

    .jumbotron-fluid {
      background: $black;
      min-height: 300px;
      padding-bottom: 50px;
    }
  }

  /* ANIMATION HANDLING */
  .service-card-content, .service-card-content-sm, .service-card-content-md {
    max-height: 3000px;
    width: 100%;
    opacity: 1;
    visibility: visible;
    overflow: hidden;
    transition: visibility 0s, opacity 0.1s, max-height 2.3s linear;

    &.hidden {
      max-height: 0;
      opacity: 0;
      visibility: hidden;
      transition: visibility 0.3s, max-height 0.3s, opacity 0.3s linear;
    }
  }

  /* Service Card Content Mobile */
  .service-card-content-sm, .service-card-content-md {
    margin-bottom: 30px;

    ul > li {
      list-style-position: inside;
    }
  }

  .service-card-content-md {
    margin-bottom: 60px;
    display: none;
    opacity: 1;

    &.hidden {
      display: none;
      opacity: 0;
    }

    &.active {
      display: block;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }

    @-webkit-keyframes slide-down {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    @-moz-keyframes slide-down {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;;
      }
    }

  }

  /**** COSMETICS ****/

  .cosmetics {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 230px;
    height: 325px;
    border: solid 3px black;
    border-radius: 10px;
    background-color: $black;

    button {
      position: absolute;
      left: 50%;
      top: 87%;
      transform: translate(-50%, -50%);
      @include font-2;
      border-radius: 10px;
      color: white;
      border: 2px solid white;
      white-space: nowrap;
    }

    .cosmetic-card {
      position: absolute;
      width: 80%;
      height: 70%;
      top: 41%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 10px;
    }

    #makeup {
      background-image: url("../../../assets/images/forty_model_1.jpg");
      background-position: 100% 50%;
      height: 75%;
    }
  }
}
</style>
